<div class="wl-blotter-container">
  <ag-grid-angular
    class="ag-theme-balham-dark wl-blotter-container__ag-grid"
    [enableRangeSelection]="true"
    [columnDefs]="$any(columnDefs)"
    [sideBar]="sideBarDef"
    (gridReady)="onGridReady($event)"
    (selectionChanged)="onSelectionChanged()"
  >
  </ag-grid-angular>
  <div class="wl-blotter-container__footer" [formGroup]="form">
    <div class="wl-blotter-container__footer__last-updated">
      Last updated: {{ lastUpdatedAtStr }}
    </div>

    <clr-date-container>
      <input
        class="input-date"
        type="date"
        clrDate
        [placeholder]="'DD MMM YYYY'"
        formControlName="date"
      />
    </clr-date-container>

    <button
      class="ui-button ui-button__footer"
      [disabled]="!form.get('date').valid"
      (click)="getRequestsStatus()"
    >
      Update
    </button>

    <div class="back-to-back-trade-container">
      <button
        class="ui-button ui-button__footer"
        (click)="displayBackToBackBlotter()"
      >
        Report
      </button>
    </div>

    <button
      class="ui-button ui-button__footer"
      [disabled]="!selectedTrade"
      (click)="onViewButtonClick()"
    >
      View
    </button>

    <app-deal-details-graph
      *ngIf="isDealDetailsOpen"
      (closeComponent)="closeContainer()"
      [selectedTrade]="selectedTrade"
    >
    </app-deal-details-graph>
  </div>
</div>
